export const getScoreTextColor = (value: number) => {
  if (value >= 70) {
    return "text-green-600";
  }
  if (value >= 50) {
    return "text-monochrome-900";
  }
  if (value >= 30) {
    return "text-yellow-600";
  }
  return "text-red-600";
};

export const platformOrders: Record<string, number> = {
  instagram: 1,
  facebook: 2,
  youtube: 3,
  tiktok: 4,
};
